import { Subtext } from './FeatureTablePriceDisplay';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableFreePriceDisplay = () => {
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsx(Subtext, {
    className: "m-top-0",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "featureTable.pricing_jsx",
      elements: {
        PriceDisplay
      },
      options: {
        currencyCode,
        seleniumId: 'free',
        price: 0
      }
    })
  });
};
export default FeatureTableFreePriceDisplay;